import React from 'react';
import {Alert, Typography} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * Single-claim extrinsic correction (warning-only, no fix suggestions).
 */
export default function ClaimExtrinsicAlert({note}) {
    if (!note || String(note).trim() === '') return null;

    return (
        <Alert
            severity="warning"
            icon={<WarningAmberIcon fontSize="small" />}
            sx={{alignItems: 'flex-start', py: 1}}
        >
            <Typography variant="caption" sx={{fontWeight: 700, display: 'block', mb: 0.25}}>
                Extrinsic correction
            </Typography>
            <Typography variant="body2" sx={{fontSize: '0.85rem'}}>
                {String(note)}
            </Typography>
        </Alert>
    );
}
